import { render, staticRenderFns } from "./PayableTable.vue?vue&type=template&id=2ac12794&"
import script from "./PayableTable.vue?vue&type=script&lang=js&"
export * from "./PayableTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports